<div class="candidate-contacts">
  @for (infoItem of contactsInfoMap | keyvalue; track infoItem) {
    @if (infoItem.value) {
      <div class="candidate-contacts__row">
        <app-card-extend-contacts-row
          [redesigned]="true"
          [contactInfoItem]="infoItem.value"></app-card-extend-contacts-row>
      </div>
    }
  }
</div>
